import { useContext } from "react";
import { OrderContext } from "./OrderProvider";
import { OrderWithPrescription } from "src/api/types";

export function useOrder<T>(selector: (order: OrderWithPrescription) => T) {
  const order = useContext(OrderContext);

  if (order == null) {
    throw new Error("useOrder is used outside of OrderProvider");
  }

  return selector(order);
}
